<template>
  <div class="home" @touchstart="touchstart" @touchmove.prevent="touchmove">
    <div class="home__bg"></div>
    <div class="home__text" v-show="showText" :class="hide ? 'animated fadeOutUpFixed' : ''">
      <transition name="fade">
        <img src="@/assets/imgs/home/text1.png" class="home__text__1" v-show="showIndex > 0">
      </transition>
      <transition name="fade">
        <img src="@/assets/imgs/home/text2.png" class="home__text__2" v-show="showIndex > 1">
      </transition>
      <transition name="fade">
        <img src="@/assets/imgs/home/text3.png" class="home__text__3" v-show="showIndex > 2">
      </transition>
    </div>
    <transition name="fade">
      <div v-show="showIndex > 3" class="home__swipe animated fadeInDown">
        <img src="@/assets/imgs/home/swipe.png" :class="hide ? 'animated fadeOutUpFixed' : 'wanderVer'">
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['showText'],
  data() {
    return {
      showIndex: 0,
      hide: false,
      swipeEnabled: false
    }
  },
  methods: {
    toScene() {
      this.hide = true
      clearTimeout(this.timeout)
      this.$bus.musicFadeOut('typing2')
      this.$emit('toScene')
    },
    touchstart(e) {
      if (this.swipeEnabled) this.startY = e.touches[0].clientY
    },
    touchmove(e) {
      if (this.swipeEnabled) {
        const y = e.touches[0].clientY
        const dy = this.startY - y
        if (dy >= 50) {
          this.swipeEnabled = false
          this.toScene()
        }
      }
    }
  },
  watch: {
    showText(val) {
      if (val) {
        this.timeout = setTimeout(() => {
          this.showIndex += 1
          this.$bus.playMusic('typing2')
          this.timeout = setTimeout(() => {
            this.showIndex += 1
            this.timeout = setTimeout(() => {
              this.showIndex += 1
              this.timeout = setTimeout(() => {
                this.showIndex += 1
                this.swipeEnabled = true
                this.$bus.musicFadeOut('typing2')
              }, 800)
            }, 800)
          }, 800)
        }, 500)
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/style/mixin.scss';

.home {
  @include fullscreen;
  z-index: 800;
  &__bg {
    @include fullscreen;
    @include bg-cover;
    opacity: .9;
    background-image: url("~@/assets/imgs/loading/bg.png");
  }
  &__text {
    @include clear;
    position: absolute;
    width: 2.44rem;
    margin-left: -1.22rem;
    margin-top: -2.26rem;
    left: 50%;
    top: 40%;
    height: 4.52rem;
    &__1 {
      top: -1.1rem;
      height: 3.68rem; 
    }
    &__2 {
      height: 4.52rem;
    }
    &__3 {
      top: 1.5rem;
      height: 3.68rem;
    }
    img {
      margin: 0 .2rem;
      float: right;
      display: block;
      position: relative;
    }
  }
  &__swipe {
    width: .8rem;
    position: absolute;
    bottom: 10vh;
    left: 50%;
    margin-left: -.4rem;
    img {
      width: 100%;
      display: block;
    }
  }
}
</style>